import React from 'react';

export default function LayoutDefault({ children }) {
  return (
    <div id="scrollContainer" className="h-full overflow-y-scroll">
      {children}
    </div>
  );
}
